import { CartPage } from '@fhs/cart';

export default CartPage;
